'use strict';
var axios = require('axios');
var { Message } = require('element-ui')


function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.hash.split("?")[1].match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}
//var token = getQueryString('token');
// var source = getQueryString('source');
// var oldUrl = getQueryString('oldUrl');
var source = '';
var oldUrl = '';
var token = '';

const CancelToken = axios.CancelToken;
let cancel;
let cancelAjaxText = '中断成功';

//var baseURL = 'https://app-ifeng-data.xfmgroup.com:8443/xfmerp-web/'  //生产
// var baseURL = 'http://10.238.96.210:8080/sicp-im' //测试
var baseURL = 'https://easy-mock.com/mock' //测试
    //var token = '8bfa0adfb1e725961dded519cbafd76c'

/* 
  当前方法封装携带五个属性
  http:axios的再次封装，需要注意的token放在请求头中，而且这里的token可能是app地址传过来的，也可能是微信公众号传来的，但都是从地址栏解析出来
  baseURL:这个参数主要是遇到区分环境的时候方便处理，主要用于pdf读取的时候用作环境变量
  source：主要用作判断跳转来源，一种是微信公众号，一种是app
  token:主要作用返回微信公众号的时候，免登陆，直接跳转到微信公众号的主页面
  oldUrl：主要是用作返回微信公众号的时候，到底返回到哪里（其实这里由于部署在两个服务器上才不得不去将原先旧的地址传过来）
*/
var xfm = {
    http: function(method, url, body, successFun, errorFun, selfParam, debug) {

        method = method.toUpperCase();
        successFun = successFun || console.log;
        errorFun = errorFun || console.log;
        debug = debug || false;
        var defaultHeaders = {};

        if (token) {
            defaultHeaders = {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "X-Auth-Token": token
            }
        } else {
            defaultHeaders = {
                "Accept": "application/json",
                "Content-Type": "application/json",
            }
        }
        var headers = JSON.parse(JSON.stringify(body.requestHeaders || defaultHeaders));

        //删除requestHeader属性，防止使用GET请求时头部参数出现在请求链接里面
        delete body.requestHeaders;

        var data = {};
        var para = {};

        if (method === 'POST' || method === 'PUT') {
            data = body;
        } else {
            para = body;
        }

        axios({
            url: url,
            baseURL: baseURL,
            method: method,
            headers: headers,
            params: para,
            data: data,
            withCredentials: false,
            cancelToken: new CancelToken(c => { //强行中断请求要用到的
                cancel = c
            })
        }).then(function(res) {

            var data = res.data;

            if (debug) {
                console.log("响应数据为：", res);
                console.log("返回成功的数据为：", data);
                console.log("传入的私有参数为：", selfParam);
            }

            if (data) {
                typeof successFun === 'function' ? successFun(data, selfParam) : null;
            } else {
                console.warn('请求成功，没有返回数据，响应数据：', res);
                typeof successFun === 'function' ? successFun(res) : null;
            }

        }, res => {
            //中断会走这
            console.log(res)
        }).catch(function(error) {
            // console.log(error)
            //console.log(error.response.headers);
            // errorFun(arguments);
            Message({
                showClose: true,
                message: error.response.data.message,
                type: 'error',
                duration: 5000
            })
            console.error(error);
        })
    },
}
var cancelAjax = function() { //强行中断请求
    if (cancel) {
        cancel(cancelAjaxText);
    }
}
export default {
    install: function(vm) {
        vm.prototype.$axios = xfm
        vm.prototype.$cancelAjax = cancelAjax
    }
}


// WEBPACK FOOTER //
// ./src/commonJs/myAxios.js